import React from 'react';
import css from 'styled-jsx/css';
import cn from 'clsx';
import ButtonBecomeCreator from '../ButtonBecomeCreator';
import withI18next from '~/../hocs/_withI18next';
import themeVariables from '~/shared/themeVariables';
import config from '~/config';
import IconUser from '~/components/svg/icon-user.svg';
import IconVerify from '~/components/svg/icon-verify.svg';
import IconCamera from '~/components/svg/icon-camera.svg';
import IconCreditCard from '~/components/svg/icon-creditcard.svg';
import Step1 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step01.svg';
import Step2 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step02.svg';
import Step3 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step03.svg';
import Step4 from '~/../static/assets/landing-page-photo-ac/photoac-landing-page-step04.svg';
import I18nLink from '~/components/I18nLink';
import { SERVICE_TYPES } from '~/utils/constants';

const steps = [
  {
    number: 1,
    labelKey: 'sign_up',
    Icon: IconUser,
    Step: Step1,
  },
  {
    number: 2,
    labelKey: 'verify_identity',
    Icon: IconVerify,
    Step: Step2,
  },
  {
    number: 3,
    labelKey: 'start_uploading',
    Icon: IconCamera,
    Step: Step3,
  },
  {
    number: 4,
    labelKey: 'earn_money',
    Icon: IconCreditCard,
    Step: Step4,
  },
];

const LOGO_BY_SERVICE_TYPE = {
  [SERVICE_TYPES.PHOTO_AC]: `${config.staticPrefix}/static/assets/image/logo/logo_photo_ac.svg`,
  [SERVICE_TYPES.ILLUST_AC]: `${config.staticPrefix}/static/assets/image/logo/logo_illust.svg`,
};

@withI18next(['page-sell-your-content'])
class SellYourContentPageMobile extends React.Component {
  render() {
    const { t, lng } = this.props;
    const faqLink =
      lng === 'tw'
        ? 'https://global.help.freebie-ac.jp/tw/'
        : 'https://global.help.freebie-ac.jp';

    return (
      <div className="sell-your-content-page-mobile">
        <div className="banner">
          <div className="container-banner">
            <I18nLink href="/">
              <a className="img-logo-wrapper">
                <img
                  className="img-logo lazyload"
                  data-srcset={LOGO_BY_SERVICE_TYPE[config.serviceType]}
                  alt="site logo"
                />
              </a>
            </I18nLink>
            {config.isPhotoAC() ? (
              <img
                className="img-banner-mobile lazyload "
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_banner_mobile.png`}
              />
            ) : (
              <img
                width="100%"
                className="img-benefit-mobile illustac lazyload"
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_banner_mobile.png`}
              />
            )}

            <div className="container-button-banner">
              <ButtonBecomeCreator t={t} display="full-width" />
            </div>
            <div className="overlay">
              <h1 className="heading-banner">
                {t('photoac_landing_page_heading_banner')}
              </h1>
              <h2 className="subheading">
                {t('photoac_landing_page_content_banner')}
              </h2>
            </div>
            <div className="container-wiggle-mobile">
              <img
                className="wiggle-mobile lazyload "
                data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle_banner_mobile.png`}
              />
            </div>
          </div>
        </div>
        <h3 className="heading-steps text-header">
          {t('photoac_landing_page_heading_step')}
        </h3>
        <div className="steps-list">
          {steps.map(({ number, labelKey, Icon, Step }) => (
            <div
              key={number}
              className={cn('step-item', `step ${config.serviceType}`)}
            >
              <div className="step-content">
                <div className="step-header">
                  <div className="step-number">
                    <span className="number">{number}</span>
                  </div>
                  <Step className="icon-number" />
                </div>
                <div className="step-body">
                  <span className="label">{t(labelKey)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="step-01-mobile-img-container lazyload">
          {config.isPhotoAC() ? (
            <img
              className="step-01-mobile-img lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_step_01_mobile.png`}
            />
          ) : (
            <img
              width="100%"
              className="img-benefit-mobile illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_benefit_mobile.png`}
            />
          )}
        </div>
        <div className={`overlay-benefit ${config.serviceType}`}>
          <h3 className="heading-benefit">
            {t('photoac_landing_page_heading_benefit')}
          </h3>
          <ul className="content-benefit">
            <li>{t('photoac_landing_page_content01_benefit')}</li>
            <li>{t('photoac_landing_page_content02_benefit')}</li>
            <li>{t('photoac_landing_page_content03_benefit')}</li>
            <li>{t('photoac_landing_page_content04_benefit')}</li>
          </ul>
          <div className="button-content">
            <ButtonBecomeCreator
              t={t}
              style={{ marginTop: themeVariables.space.base }}
              display="full-width"
            />
          </div>
        </div>
        <div className="step-01-mobile-img-container lazyload">
          {config.isPhotoAC() ? (
            <img
              className="step-01-mobile-img lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_01_mobile.png`}
            />
          ) : (
            <img
              width="100%"
              className="img-benefit-mobile illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_01_mobile.png`}
            />
          )}
        </div>
        <div className="overlay-01">
          <h3 className="heading-faq-01 text-header">
            {t('photoac_landing_page_heading_faq_01')}
          </h3>
          <ul className="content-faq-01 text-body">
            <li> {t('photoac_landing_page_content01_faq_01')} </li>
            <li> {t('photoac_landing_page_content02_faq_01')}</li>
            <li>{t('photoac_landing_page_content03_faq_01')}</li>
            <li>{t('photoac_landing_page_content04_faq_01')}</li>
            <li>{t('photoac_landing_page_content05_faq_01')}</li>
          </ul>
          <I18nLink href="/submission-guideline">
            <a className="link-submission">
              {t('photoac_landing_page_link_faq_01')}
            </a>
          </I18nLink>
        </div>
        <div className="container-wiggle-mobile-step-01">
          <img
            className="wiggle-mobile lazyload "
            data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle_banner_mobile.png`}
          />
        </div>
        <div className="step-01-mobile-img-container lazyload">
          {config.isPhotoAC() ? (
            <img
              className="step-01-mobile-img lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_faq_02_mobile.png`}
            />
          ) : (
            <img
              width="100%"
              className="img-benefit-mobile illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_faq_02_mobile.png`}
            />
          )}
        </div>
        <div className="overlay-02">
          <h3 className="heading-faq-02 text-header">
            {t('photoac_landing_page_heading_faq_02')}
          </h3>
          <ul className="content-faq-02 text-body">
            <li>
              <b> {t('photoac_landing_page_content01_faq_02')}</b>{' '}
            </li>
            <p>{t('photoac_landing_page_sub_content01_faq_02')}</p>
            <li>
              {' '}
              <b> {t('photoac_landing_page_content02_faq_02')}</b>
            </li>
            <p>{t('photoac_landing_page_sub_content01_faq_02')}</p>
            <li>
              {' '}
              <b>{t('photoac_landing_page_content03_faq_02')}</b>
            </li>
            <p>{t('photoac_landing_page_sub_content03_faq_02')}</p>
            <p>{t('photoac_landing_page_sub_content03_02_faq_02')}</p>
          </ul>
          <a href={faqLink} className="link-submission">
            {t('photoac_landing_page_link_faq_02')}
          </a>
        </div>
        <div className="container-wiggle-mobile-step-02">
          <img
            className="wiggle-mobile lazyload "
            data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle_banner_mobile.png`}
          />
        </div>
        <div className="step-01-mobile-img-container lazyload">
          {config.isPhotoAC() ? (
            <img
              className="step-01-mobile-img lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/photoac_infor_mobile.png`}
            />
          ) : (
            <img
              width="100%"
              className="img-benefit-mobile illustac lazyload"
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-illustac/illustac_infor_mobile.png`}
            />
          )}
        </div>
        <div className={`faq-infor ${config.serviceType}`}>
          <div className="faq-infor-container">
            <div className={'overlay-infor '}>
              <h3 className="heading-infor text-header">
                {t('photoac_landing_page_heading_infor')}
              </h3>
              <p className="content-infor text-body">
                {t('photoac_landing_page_content_infor')}
              </p>
            </div>
          </div>
          <div className="button-benefit">
            <ButtonBecomeCreator t={t} display="full-width" />
          </div>
          <div className="container-wiggle-mobile-content">
            <img
              className="wiggle-mobile lazyload "
              data-srcset={`${config.staticPrefix}/static/assets/landing-page-photo-ac/wiggle_content_mobile.png`}
            />
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    );
  }
}

const styles = css`
  .sell-your-content-page-mobile {
    display: none;
  }
  @media screen and (min-width: 0px) and (max-width: 729px) {
    .sell-your-content-page-mobile {
      display: block;
      margin-top: 16px;
    }
    .container-banner {
      width: 100%;
      display: block;
      flex-direction: row;
      // background: red;
      position: relative;
      padding: 0 16px;
    }
    .img-banner-mobile {
      width: 100%;
      margin-top: 16px;
    }
    .overlay {
      position: relative;
      width: 100%;
      // background: rgba(47, 59, 51, 0.5);
      display: flex;
      flex-direction: column;
      align-items: left;
      color: #fff;
      margin-top: 8px;
    }
    .container-button-banner{
      position: relative;
      width: 100%;
      margin-top:10px;
    }
    .heading-banner {
      font-size: 24px;
      padding: 0;
      text-align: left;

      font-style: normal;
      font-weight: 600;
      letter-spacing: -0.03em;
      color: #1b2833;
    }

    .subheading {

      font-style: normal;
      font-size: 16px;
      color: #1b2833;
      line-height: 28px;
      margin: 0;
      margin-bottom: 20px;
    }
    .container-wiggle-mobile {
      width: 100%;
    }
    .wiggle-mobile {
      width: 100%;
    }

    //Step
    .container-wiggle-mobile-step-01, .container-wiggle-mobile-step-02 {
      width: 100%;
      padding: 0 16px;
    }
    .heading-steps {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      padding: 0 16px;
    }
    .steps-list {
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: ${themeVariables.space.base}px;
      width: 100%;
      max-width: 1248px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 2rem;
      padding: 0 16px;
    }

    .step-item {
      position: relative;
      height: 140px;
      border-radius: 4px;
      // margin: 0 ${themeVariables.space.half}px;
      box-shadow: 4px 4px 4px rgba(27, 40, 51, 0.25);
      border-radius: 4px;
      width: 100%;
      height: 84px;
      padding-top: 0%;
    }

    .step-content {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .step-header {
      position: relative;
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      padding: 0 ${themeVariables.space.half}px;
      margin-top: ${themeVariables.space.small}px;
    }
    .step-header {
      height: 12px;
    }
    .step-body {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: ${themeVariables.space.small}px;
    }

    .step {
      background: #1b2833;
    }
    .step.illust_ac{
      background: #454285;;
    }

    .step-number {
      position: absolute;
      left: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .number {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
      position: absolute;
      left: ${themeVariables.space.half}px;
    }
    .icon-number {
      width: 22px;
      height: 22px;
    }
    .label {
      margin-top: ${themeVariables.space.base}px;


      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 28px;
      letter-spacing: -0.03em;

      color: #ffffff;
    }
    .step-01-mobile-img-container {
      width: 100%;
      position: relative;
      margin-top: 20px;
      padding: 0 16px;
      z-index:1;
    }
    .step-01-mobile-img {
      width: 100%;
    }
    //overlay benefit
    .overlay-benefit {
      position: relative;
      width: 100%;
      right: 0;
      top: 0;
      background: #1b2833;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      color: #fff;
      z-index: 800;
      margin-top: 20px;
      padding-top: 48px;
      padding-bottom: 48px;
    }
    .overlay-benefit.illust_ac{
      background:#454285;
      margin-top:-20px;
      z-index:0;
    }
    .heading-benefit {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 28px;
      letter-spacing: -0.03em;

      /* MILKY */

      color: #ffffff;
      padding-left: 12px;
      margin: 0;
      margin-bottom: 24px;
    }
    .content-benefit {

      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      /* identical to box height, or 175% */

      /* MILKY */

      color: #ffffff;
    }
    .content-benefit li {
      margin: 8px 0;
    }
    .button-benefit {
      position: relative;
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
      padding: 0 16px;
    }
    /// content faq 01
    .overlay-01 {
        position: relative;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        // background: rgba(47, 59, 51, 0.5);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: #fff;
        padding: 16px;
        padding-bottom: 8%;
        padding-top: 2%;

        z-index: 800;
      }
      .heading-faq-01 {

        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 28px;
        color: #1b2833;
      }
      .content-faq-01 {

        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #1b2833;
        list-style-type: none;
        padding-left: 0; */
      }
      .content-faq-01 li {
        margin: 8px 0;
      }
      .link-submission{

        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        text-decoration-line: underline;
        color: #509BDC;
      }
      .container-faq-img-01{
        position: relative;
        top: -50px;
        width: 50%;
      }
      .img-faq-01 {
        position: relative;
        width: -webkit-fill-available;
      }

      //FAQ 02
      .overlay-02 {
        position: relative;
        width:100%;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: #fff;
        padding: 16px;
        padding-top: 0%;
        z-index: 800;
      }
      .img-faq-02 {
        position: absolute;
        left: 0;
        top: 12%;
        width:45%;
      }
      .heading-faq-02 {

        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        color: #1b2833;
      }
      .content-faq-02 {

        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #1b2833;
        list-style-type: none;
        padding-left: 0; */
      }
      .content-faq-02 li {
        margin: 8px 0;
      }
      .faq-infor{
        width:100%;
        height: 584px;
        background: #1B2833;
        display: block;
        flex-direction: row;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        margin-top:20px;
      }
      .faq-infor.illust_ac{
        background:#454285;
        margin-top:-20px;
        z-index:0;
      }
      .faq-infor-container{
        width: 100%;
        display: block;
      }
      .overlay-infor {
        position: relative;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: left;
        color: #FFFFFF;
        padding: ${themeVariables.space.half}px;
        padding-bottom: 5%;
        padding-top: 0%;
        z-index: 800;
      }

      .heading-infor{
        color: #FFFFFF;
        margin: 32px 0px;
        font-weight: 600;
        font-size: 24px;
      }
      .content-infor{
        color: #FFFFFF;
      }
      .img-infor{
        position: absolute;
        right: 0;
        top: -25%;
      }
      .container-wiggle-mobile-content{
          width:100%;
          padding: 0 16px;
      }
      .button-content {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 10px;
        padding: 0 16px;
      }
  }
`;

export default SellYourContentPageMobile;
